/**
 * Properties map
 */

export default function initPropertiesMap(){
	const clickableStates = document.querySelectorAll('.properties-map__image [data-termid]');

	clickableStates.forEach(state => {
		state.setAttribute('role', 'link'); // Accessibility
		state.setAttribute('aria-pressed', 'false');

		// Click and keyboard support
		state.addEventListener('click', handleInteraction);
		state.addEventListener('keydown', function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleInteraction.call(this, e);
		}
		});
	});
}

async function handleInteraction(e) {
	const termId = this.getAttribute('data-termid');
	if (!termId) return;

	try {
		const result = await fetch(`/wp-admin/admin-ajax.php?action=cs__ajax_property_category_term_URL&term_id=${termId}`);
		const json = await result.json();

		window.location.href = json.data.url;
	} catch ( err ){
		console.log('Failed to fetch state URL.');
	}
}